"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgExpiringPageProvider = void 0;
const react_1 = __importDefault(require("react"));
const react_use_1 = require("react-use");
const constants_iso_1 = require("@wranggle/constants-iso");
const shared_browser_utils_1 = require("@wranggle/shared-browser-utils");
const WsClientSyncProvider_1 = require("./WsClientSyncProvider");
function OrgExpiringPageProvider(args = {}) {
    const { routeDef, apiBaseUrl, connectionInstructions, children } = args;
    const { pathname } = react_use_1.useLocation();
    const [authState, doAuth] = react_use_1.useAsyncFn(({ browserWindowUid }) => __awaiter(this, void 0, void 0, function* () {
        if (connectionInstructions) {
            return connectionInstructions();
        }
        let wranggleAccountUid = args.wranggleAccountUid;
        let pageDefUid = args.pageDefUid;
        if (!wranggleAccountUid || !pageDefUid) {
            const pathData = shared_browser_utils_1.matchRouteVars({
                routeDef: routeDef || constants_iso_1.BrowserSpaRoute.Landing_SyncOrgExpiringPage,
                pathWithData: document.location.pathname || '',
            }) || {};
            wranggleAccountUid = wranggleAccountUid || pathData.wranggleAccountUid || pathData.organizationUid || pathData.org;
            pageDefUid = pageDefUid || pathData.pageDefUid || pathData.page;
        }
        if (!wranggleAccountUid || !pageDefUid) {
            throw new shared_browser_utils_1.PlusPlusPlus('InvalidPathData', {
                reason: 'wranggleAccountUid and pageDefUid are required, either extracted from the document.location path or passed in directly',
                wranggleAccountUid, pageDefUid,
                pathRouteDef: routeDef,
            });
        }
        const url = shared_browser_utils_1.endpointUrl({
            baseUrl: apiBaseUrl || shared_browser_utils_1.wranggleBackendApiBaseUrl(),
            routeDefinition: constants_iso_1.OrgTokenRoute.OrgPageDataAuth,
            embeddedData: {
                organizationUid: wranggleAccountUid,
                pageDefUid,
                browserWindowUid,
            }
        });
        const resp = yield shared_browser_utils_1.httpFetchWithRetriesAndTimeout({
            url,
            method: 'GET',
        });
        const instructions = yield resp.json();
        return instructions;
    }), [pathname, args.wranggleAccountUid, args.pageDefUid, apiBaseUrl, connectionInstructions]);
    return react_1.default.createElement(WsClientSyncProvider_1.WsClientSyncProvider, { fetchConnectionInstructions: doAuth }, children);
}
exports.OrgExpiringPageProvider = OrgExpiringPageProvider;
//# sourceMappingURL=OrgExpiringPageProvider.js.map